import React, { useMemo } from 'react'
import { Button, Label, Loading } from '@therms/atalaya'
import {
  RPCDocs,
  useLocationContext,
  useReportTypes,
} from '@therms/react-modules'
import { groupBy } from 'lodash-es'
import { getColorContrast } from '@therms/web-js'

interface PickReportTypeProps {
  onSelectReportType: (
    reportType: RPCDocs.Reports.GetReportTypesList.v1.ReportType,
  ) => void
}

function PickReportType({ onSelectReportType }: PickReportTypeProps) {
  const { data, loading } = useReportTypes({
    active: true,
    pagination: { limit: 100 },
  })
  const locationContext = useLocationContext()

  const reportTypesCategoryGroups = useMemo(() => {
    let filteredReportTypes

    if (locationContext && data) {
      filteredReportTypes = data.reportTypes.filter(
        (type) => type.allowedRefs.locations === true,
      )
    }

    return Object.entries(
      groupBy(
        filteredReportTypes?.length ? filteredReportTypes : data?.reportTypes,
        'category',
      ),
    )
  }, [data])

  if (loading) return <Loading overlay />

  return (
    <div>
      {reportTypesCategoryGroups.map(([category, reportTypes]) => (
        <div className="mb-3" key={category}>
          <div className="mb-1">
            <Label>{category}</Label>
          </div>

          <div className="grid grid-cols-3 gap-lg">
            {reportTypes
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map(({ color, id, name }, i) => (
                <Button
                  key={id}
                  onClick={() => onSelectReportType(reportTypes[i])}
                  style={{
                    backgroundColor: color,
                    color: getColorContrast(color),
                  }}
                  className="py-base"
                >
                  {name}
                </Button>
              ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export { PickReportType }
